module.exports = __webpack_public_path__ + "img/pc_p3_z5.3bfd6d3a.png";